// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './demo.vue'
import '../common/main.js'

import BasicInformation from './components/sections/basicInformation'
import TimeLine from './components/sections/timeLine'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: BasicInformation },
  { path: '/basicInformation', component: BasicInformation },
  { path: '/timeLine', component: TimeLine }
]

const router = new VueRouter({
  routes
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  template: '<App/>',
  router,
  components: { App }
})



// WEBPACK FOOTER //
// ./src/modules/demo/demo.js